import { apiRequest } from '@/utils/api-request';
import * as Sentry from '@sentry/react';

export interface DeleteWorkflowRunResponse {
  success?: boolean;
  message?: string;
  detail?: string;
}

/**
 * Deletes a past workflow run.
 * @param workflowId - The workflow ID
 * @param runId - The run ID to delete
 * @param orgId - The organization ID
 * @returns Promise containing the delete response
 */
export async function deleteWorkflowRun(
  workflowId: string,
  runId: string,
  orgId: string,
): Promise<DeleteWorkflowRunResponse> {
  try {
    const response = await apiRequest<DeleteWorkflowRunResponse>({
      url: `/api/v1/orgs/${orgId}/workflows/${workflowId}/runs/${runId}`,
      target: 'workflow',
      method: 'DELETE',
    });

    if (response.detail) {
      throw new Error(response.detail);
    }

    return response.data || { success: true };
  } catch (error) {
    console.error('Error deleting workflow run:', error);
    Sentry.captureException(error, {
      extra: { context: 'delete-workflow-run' },
    });
    throw error;
  }
}
